export default __webpack_public_path__ + "static/media/headbanner.759c6cdb.png";